export async function copyTextToClipboard(text: string): Promise<boolean> {
  if (
    navigator.clipboard &&
    typeof navigator.clipboard.writeText === "function"
  ) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (err) {
      console.error("Failed to copy text via clipboard API: ", err);
    }
  }

  const textarea = document.createElement("textarea");
  textarea.textContent = text;
  document.body.appendChild(textarea);
  textarea.focus();
  textarea.select();
  try {
    const successful = document.execCommand("copy");
    if (!successful) {
      console.error("Failed to copy text via execCommand.");
    }
    return successful;
  } catch (err) {
    console.error("execCommand error: ", err);
    return false;
  } finally {
    document.body.removeChild(textarea);
  }
}
